<div class="p-grid table-demo manage-product-section">
    <div class="p-col-12">
        <div class="card">
            <!-- <p-toast key="toastmsg"></p-toast> -->
            <!-- <button (click)="addKyc(userId)" pButton pRipple label="Add" class="p-button-success p-col-1 "  icon="pi pi-plus"></button> -->
            <h3>Academy User KYC List</h3>
            <p-toolbar styleClass="p-mb-4">
				<ng-template pTemplate="left">
					<!-- <button pButton pRipple label="New" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="addNewUser()"></button> -->
					<button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2"
						icon="pi pi-filter-slash" (click)="clear()
					"></button>
                    <!-- <button pButton  disabled label="update" class="p-button-outlined p-mr-2 p-mb-2"
                    icon="pi pi-filter-slash" (click)="encryptData() "></button> -->
				</ng-template>
				<ng-template pTemplate="right">
					<button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
						class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
					<!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
				</ng-template>
			</p-toolbar>
            <p-table class="p2-table-columns show-columns" #dt [value]="userlist" [lazy]="true"[paginator]="true" [rows]="10" 
                (onLazyLoad)="loadUserKyc($event)" [totalRecords]="totalRecords" [loading]="loading" autoLayout="true" [rowsPerPageOptions]="paginationOption"
                styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="min-width: 100px;">Academy Name</th>
                        <th style="min-width: 100px;">Username</th>
                        <!-- <th style="min-width: 100px;">Pan Image</th> -->
                        <th class="bankDetails-td">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Bank Details

                            </div>
                        </th>
                        <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                A/C Number
                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                IFSC
                            </div>
                        </th> -->
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Pan Number
                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                        Aadharcard Number
                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                GST Number
                            </div>
                        </th>

                        <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                State Name

                            </div>
                        </th>
                        <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                City Name

                            </div>
                        </th> -->
                        <th class="address-td">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Address

                            </div>
                        </th>
                        <!-- <th >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Zip Code

                            </div>
                        </th> -->
                        <th class="dateTD" >
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Date
                            </div>
                        </th>
                        <th class="status-Td">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Status
                            </div>
                        </th>
                       
                        <!-- <th class="">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Action
                            </div>
                        </th> -->

                    </tr>
                    <tr>
                        <th [ngSwitch]="academyName" class="NameTD">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
								[value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
						</th>
						<th [ngSwitch]="userName" class="NameTD">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
								[value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
						</th>
						<!-- <th [ngSwitch]="lastName" class="NameTD">
							
						</th> -->
						<th [ngSwitch]="gender" class="gender-td">
							
						</th>
						<th [ngSwitch]="pancardNumber"  class="emailTD">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'pancardNumber', 'contains')"
								[value]="dt.filters['pancardNumber'] ? dt.filters['pancardNumber'].value : ''" />
						</th>
                        <th [ngSwitch]="adharCardNumber"  class="emailTD">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'adharCardNumber', 'contains')"
								[value]="dt.filters['adharCardNumber'] ? dt.filters['adharCardNumber'].value : ''" />
						</th>
						<th [ngSwitch]="gstNumber"  class="gstNumberTD">
							<input pInputText type="text"
								(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstNumber', 'contains')"
								[value]="dt.filters['gstNumber'] ? dt.filters['gstNumber'].value : ''" />
						</th>
						<th [ngSwitch]="dob" class="">
					
						</th>
						<!-- <th [ngSwitch]="weddingDate" class="">
							<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'weddingDate', 'dateIs')"
								[showIcon]="true" [(ngModel)]="wdcalvalue"></p-calendar>
						</th> -->
						<th [ngSwitch]="updated_at" class="Modificationdatetd" >
							<!-- <p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
								(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
								[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar> -->
						</th>
						<th [ngSwitch]="status" class="status-Td" >
							<p-dropdown #pDropDownId [options]="statuses"
								(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
								styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
								<ng-template let-option pTemplate="item">
									<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
								</ng-template>
							</p-dropdown>
                            <!-- <p-dropdown [style]="{ width: '100%' }" inputId="id" appendTo="body" [showClear]="true"
                            [options]="statuses" [filter]="true" placeholder="All" [(ngModel)]="searchbystatus"
                            optionLabel="label" (onChange)="onStatuSelect($event)"></p-dropdown> -->
						</th>
						<!-- <th> -->
							<!-- <button pButton [style]="{'margin-left':'20px'}" icon="pi pi-plus" class="p-button-rounded" (click)="addColumns()"></button> -->
						<!-- </th> -->
					</tr>

                </ng-template>
                <ng-template pTemplate="body" let-userlist>
                    <tr class="p-selectable-row" *ngIf="noData">
                        <td>
                            {{userlist.acadmey}}
                        </td>
                        <td>
                            {{userlist.userdetail[0].fullName}}
                        </td>
                        <!-- <td class="pan-image-td"> 
                            <div class="pan-image"  (click)="openHightlightImage(userlist);"> 
                                <img [src]=userlist.pancardPic [alt]="userlist.name" 
                                width="300" class="shadow-4" />
                            </div>
                          <div class="button-div"  (click)="openHightlightImage(userlist);">
                            <button pButton pRipple type="button" icon="pi pi-eye"  class="p-button-rounded"></button>
                            <p>View Image</p>
                          </div>
                          </td> -->
                          <td class="bankDetails-td">
                            <span *ngFor="let bankdata of userlist.bankData">
                                <span><b>Bank Name:</b> {{bankdata.bankName}}</span>
                                <span><b>A/C Number:</b> {{bankdata.bankAccountNumber}}</span>
                                <span><b>IFSC Number:</b> {{bankdata.ifsc}}</span>
                                </span>
                        </td>
                        
                        <!-- <td>
                            {{userlist.accountNumber}}
                        </td>
                        <td>
                            {{userlist.ifsc}}
                        </td> -->
                        <td>
                            {{userlist.panCardNumber}}
                        </td>
                        <td>
                            {{userlist.aadhaarCardNumber}}
                        </td>

                        <td>
                            {{userlist.gstNumber}}
                        </td>

                        <!-- <td>
                            {{userlist.statename}}
                        </td>
                        <td>
                            {{userlist.cityname}}
                        </td> -->
                        <td class="address-td">
                            <span *ngIf="userlist.isAadharVerified"> {{userlist.fullAddress?.house}},{{userlist.fullAddress?.street}},{{userlist.fullAddress?.landmark}},{{userlist.fullAddress?.po}}-{{userlist.fullAddress?.pincode}},{{userlist.fullAddress?.state}},{{userlist.fullAddress?.country}}</span>
                        </td>
                        <!-- <td>
                            {{userlist.zipcode}}
                        </td> -->
                        <td class="dateTD">
                            {{userlist.created_at | date:'dd/MM/yyyy'}}
                        </td>
                        <td class="status-Td">
                            <p-tag class="bg-success text-white" *ngIf="userlist.iskycCompleteVerified"
                            [rounded]="true">Approved</p-tag>
                        <p-tag class="bg-warning text-dark" *ngIf="!userlist.iskycCompleteVerified"
                            [rounded]="true">Pending</p-tag>
                        </td>
                        <!-- <td>
                            
                            <button 
                                class="btn btn-success" (click)="changeStatus(userlist)"> Approve </button>
                            <button [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"
                                class="btn btn-danger" (click)="showrejectmodal(userlist)"> Reject </button>

                            <button pButton pRipple icon="pi pi-pencil" [disabled]="userlist.isRejected"
                                class="p-button-rounded p-button-success p-mr-2" pTooltip="edit"
                                ></button>
                        </td> -->
                        <!-- <td class="action-button-td">
                            <div class="status-button w-100">
                                <p-button icon="pi pi-pencil" [ngClass]="{'disabled-button-class': userlist.isRejected}" [rounded]="true" severity="warning" [disabled]="userlist.isRejected"  class="buttons btn btn-warning " routerLink="/manage/user/kyc/add-kyc/{{userlist.Id}}/0/{{userlist.userId}}"  pTooltip="Edit " tooltipPosition="bottom"> </p-button>
                                <p-button icon="pi pi-check"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}" [rounded]="true" severity="success" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected"  class="buttons btn btn-success" (click)="changeStatus(userlist)" pTooltip="Approved " tooltipPosition="bottom"> </p-button>
                                <p-button icon="pi pi-times"  [ngClass]="{'disabled-button-class': !userlist.isDocumentComplete || userlist.status || userlist.isRejected}"  [rounded]="true" severity="danger" [disabled]="!userlist.isDocumentComplete || userlist.status || userlist.isRejected" class="buttons btn btn-danger" (click)="showrejectmodal(userlist)" pTooltip="Reject" tooltipPosition="bottom"> </p-button>
                            </div>
                        </td> -->
                       
                        <!-- <td  class="actionTD">

                        </td> -->
                        
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary"  >
                    <div  class="flex align-items-center justify-content-between">
                        In total there are {{totalRecords}} KYC Records
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>


<p-galleria [(value)]="userlist" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '600px' }" [numVisible]="7" [circular]="true" [fullScreen]="true"
    [showItemNavigators]="false" [showThumbnails]="false">
    <ng-template pTemplate="item" let-userlist>
        <img  [src]=showHighlightImg [alt]="userlist.name" style="width: 100%; display: block;" />
    </ng-template>
</p-galleria>
<p-dialog header="Mention Reject Reason" [(visible)]="rejectKyc" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select">
    <form [formGroup]="rejectUpdateForm" >
        <div class="p-grid">
            <div class="col-12">
                <div class="form-div">
                    <label for="comment"> Add Reason <span class="mandatory-fields ">*</span>
                    </label>
                    <textarea pInputTextarea rows="5" formControlName="comment"
                        [ngClass]="{ 'is-invalid': submitted && f.comment.errors }"></textarea>
                    <div *ngIf="((submitted && f.comment.errors) || (f.comment.errors && (f.comment.dirty || f.comment.touched)))"
                        class="invalid-feedback">
                        <div *ngIf="f.comment.errors.required">
                            Reason is required</div>
                    </div>
                </div>
            </div>
            <div class="col-12 footer-forms">
                <button class="btn btn-danger" (click)="changeStatusToReject()" type="submit"> Reject </button>
            </div>
        </div>
    </form>
</p-dialog>
<p-dialog header="Reason of Rejection" [(visible)]="rejectKycReasonView" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false" class="modal-payment-select">
   <div>
    {{viewReason}}
   </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
